// Resize + JPEG-encode a user-selected image to a compact data URL suitable
// for storing directly in `avatar_url`. Keeps DB rows small (~15-40kb) while
// giving avatars enough resolution for 2x/retina displays.
export async function resizeImageToDataUrl(file, maxSize = 320, quality = 0.85) {
  if (!file) throw new Error("no file");
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("read_failed"));
    reader.readAsDataURL(file);
  });
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error("decode_failed"));
    i.src = dataUrl;
  });
  const w = img.width;
  const h = img.height;
  const side = Math.min(w, h); // center-crop to square
  const sx = (w - side) / 2;
  const sy = (h - side) / 2;
  const cw = Math.min(maxSize, side);
  const canvas = document.createElement("canvas");
  canvas.width = cw;
  canvas.height = cw;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, sx, sy, side, side, 0, 0, cw, cw);
  return canvas.toDataURL("image/jpeg", quality);
}
